
import React, { useState } from 'react'
import {  PasscodeInput, Button, Form, Input, TextArea, Toast, Space, Swiper, Image, AutoCenter, Divider, Card } from 'antd-mobile'

import { request } from '@/utils'
import "./index.scss";

const Ylso3 = () => {

    const token = JSON.parse(localStorage.getItem('cx315_token'))
    const [openyz, setOpenyz] = useState(true)// 验证码
    const [openwl, setOpenwl] = useState(false)//物理信息

    const [shzt, setShzt] = useState(token.e_json.tcard_lqzt) //收货信息状态
    const [shmsg, setShmsg] = useState(token.e_json.tcard_msg) //收货信息
    const [ttoken, setTtoken] = useState() // 设置token  用于验证验证通过凭证

    const imgjsonz = token.pjson1.imgjson


    const imgjson = imgjsonz !== undefined ? imgjsonz.map((e) => (
        <Swiper.Item key={e.uid}>
            <Image src={e.url} />
        </Swiper.Item>
    )) : [];

    const tyzdo = async (e) => {
        
        const ngmsj = { dbcode: token.resq.dbcode, dbno: token.resq.dbno, yzcode: e, istcard: "Y" };
        const res = await request.post('/p_qrcode_yz', ngmsj)
        // res.return_code === "F" && setOpener(true)
        res.return_code === "success" && setTtoken(res.e_json.ttoken)
        res.return_code === "success" && setOpenwl(true) //打开物理填写信息
        res.return_code === "success" &&  setOpenyz(false)  //关闭验证码
        res.return_code === "success" && res.e_json.tcard_lqzt === "Y" && setShmsg(res.e_json.tcard_msg)
        Toast.show({
            content: res.return_msg,
            maskClickable: false,
        })
    }
    // 
    const onFinish = async (e) => {
        const ngmsj = { dbcode: token.resq.dbcode, dbno: token.resq.dbno, ttoken: ttoken };
        const njson = Object.assign(e, ngmsj);
        const res = await request.post('/p_qrcode_tc', njson)
        res.return_code === "success" && setShmsg(res.tcard_msg)
        res.return_code === "success" && setShzt("Y")
        res.return_code === "success" && Toast.show({
            content: '已处理，请等待商家处理',
            maskClickable: false,
        })
    }
   
    console.log("验证状态药",shzt)

    document.title = "提货卡";
    return <>
        {imgjsonz !== undefined && <Swiper loop
            autoplay>
            {imgjson}
        </Swiper>}

        {/*  */}
        {shzt === "N" && openyz && <AutoCenter
        // style={{marginTop:'20px'}}
        >
            <Divider
                style={{
                    color: '#1677ff',
                    borderColor: '#1677ff',
                    borderStyle: 'dashed',
                }}
            >
                请输入验证码提货
            </Divider>
            <PasscodeInput plain onFill={tyzdo}
            // style={{"--border-color":"#7cb305"}}
            /></AutoCenter>}

        {shzt === "N" &&  openwl && <div style={{ height: '60vh', overflowY: 'scroll', padding: '10px 10px 50px 10px' }} >

            <Form
                layout='horizontal'
                onFinish={onFinish}
                footer={<Button block type='submit' color='success' size='large'>  提 货</Button>}
            >

                <Form.Item
                    name='shmc'
                    label='收货人'
                    rules={[{ required: true, message: '收件人不能为空' }]}
                >
                    <Input placeholder='请填写收货人' />
                </Form.Item>


                <Form.Item
                    name='shphone'
                    label='联系电话'
                    rules={[{ required: true, message: '联系电话不可为空' }]}
                >
                    <Input placeholder='请填写联系电话' />
                </Form.Item>
                <Form.Item name='address' label='收件地址' rules={[{ required: true, message: '收件地址不能为空' }]}>
                    <TextArea
                        placeholder='请输入地址'
                        maxLength={200}
                        rows={5}
                        showCount
                    />
                </Form.Item>


            </Form>



        </div>
        }

        {
       shzt==="Y" && <Card ><Space direction='vertical' style={{ fontSize: "1.2em" }}>
            { shzt==="Y" && shmsg.shmc!==undefined && <>收货名称:{shmsg.shmc}</>}
            { shzt==="Y" && shmsg.shphone!==undefined  && <>联系电话:{shmsg.shphone}</>}
            {shzt==="Y" &&  shmsg.address!==undefined  && <>收货地址:{shmsg.address}</>}
            {shzt==="Y" &&  shmsg.kdmc!==undefined  && <>快递名称:{shmsg.kdmc}</>}
            {shzt==="Y" && shmsg.kdbill!==undefined  && <>快递单号:{shmsg.kdbill}</>}
        </Space></Card>}
{console.log(shmsg)}


        {token.json.cpxq !== undefined && <div className='fuwenben' dangerouslySetInnerHTML={{ __html: decodeURIComponent(token.json.cpxq) }} ></div>}

       


    </>

}

export default Ylso3;